import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../../constants/colors';
import {Icon} from '../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../atoms/Icon/IconName';
import {UnstyledLink} from '../../../atoms/UnstyledLink/UnstyledLink';
import {LinkBadges} from './LinkBadges';
import {GridItem} from './LinksGrid';

interface LinkGridItemProps extends GridItem {
  className?: string;
  dataTestId: string;
  onLinkItemClick: () => void;
}

export const LinkItem: React.FC<LinkGridItemProps> = ({
  badges,
  className,
  dataTestId,
  label,
  onLinkItemClick,
  textColor,
  url,
  saleIcon,
}) => {
  const handleLinkItemOnClick = () => {
    onLinkItemClick();
  };

  return (
    <Wrapper
      className={className}
      data-testid={dataTestId}
      onClick={handleLinkItemOnClick}
      to={url.url}
      textcolor={textColor || COLORS.Black}
      aria-label={undefined}
    >
      <LabelContainer>
        {label}
        {saleIcon && (
          <StyledSaleIcon
            fill={saleIcon.color.hex}
            size="XS"
            asset={GenericIconName.Sale}
          />
        )}
      </LabelContainer>
      {badges.length > 0 && <LinkBadges badges={badges} />}
    </Wrapper>
  );
};

const Wrapper = styled(UnstyledLink)<{textcolor: string}>`
  display: flex;
  align-items: baseline;
  color: ${({textcolor: textColor}) => textColor};
  position: relative;

  &::after {
    content: '';
    margin-left: 8px;
    opacity: 0;
    transition: opacity 0.3s ease;
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M17 11.999L15.16 13.859 9.073 20 7.4 18.31 13.485 12.17 13.655 11.999 13.485 11.83 7.4 5.689 9.073 4 15.16 10.141 15.327 10.311z"/></svg>');
    background-size: contain;
    width: 8px;
    height: 8px;
  }

  &:hover {
    text-shadow: 0 0 0.5px rgba(0, 0, 0, 0.3);
    &::after {
      opacity: 1;
    }
  }
`;

const StyledSaleIcon = styled(Icon)`
  margin-left: 4px;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
`;
